<app-header></app-header>

<app-loader></app-loader>

<router-outlet></router-outlet>
